import { useQuery } from "@tanstack/react-query";
import { getApiIntegrationsProductItemsNorthmillBrands } from "apiClients/base-generated";
import { getHeyApiRequestOptions, normalizeHeyApiLang } from "apiClients/base/heyApiRequestOptions";

function heyApiResultToError(err: unknown): Error {
  const message = typeof err === "string" ? err : JSON.stringify(err);
  return new Error(message);
}

/** Page size for Northmill group listing (API route name still uses “brands” in OpenAPI). */
export const DEFAULT_NORTHMILL_GROUPS_PAGE_SIZE = 500;

export type NorthmillGroupsQueryOptions = {
  pageSize?: number;
};

export function useNorthmillGroupsQuery(locale: string | null | undefined, options?: NorthmillGroupsQueryOptions) {
  const lang = normalizeHeyApiLang(locale);
  const pageSize = options?.pageSize ?? DEFAULT_NORTHMILL_GROUPS_PAGE_SIZE;

  return useQuery({
    queryKey: ["northmill-groups", lang ?? "default", pageSize],
    queryFn: async () => {
      const result = await getApiIntegrationsProductItemsNorthmillBrands({
        ...getHeyApiRequestOptions(lang),
        query: { pageSize },
      });
      if (result.error) {
        throw heyApiResultToError(result.error);
      }
      return result.data ?? null;
    },
  });
}
